export default __webpack_public_path__ + "static/media/bg.9035dc2e.jpg";